import { createContext, useContext } from 'react';

/**
 * Indica si el slide que envuelve el `content` está activo (centrado y visible)
 * en el track del WelcomeOnboardingDialog. Todos los slides se montan a la vez,
 * así que un `content` con animaciones/temporizadores propios (p. ej. la
 * pantalla de "IA generando") debe esperar a este flag para arrancar y no
 * dispararse mientras está fuera de viewport.
 */
export const SlideActiveContext = createContext<boolean>(false);

/** True cuando el slide que contiene este nodo está activo. */
export function useSlideActive(): boolean {
  return useContext(SlideActiveContext);
}
